
(function () {

    'use strict';
    // document.domain = 'cologic.de';


    /*global $:true */

    //Annahme: jQuery oder Zepto geladen
    $(document).ready(function () {
        cologic.init();
    });

    //------------------------------

    let cologicCore = {

        isDesktop: false,
        isMobile: false,
        isSmartPhone: false,
        sortTag: 'modelljahr',

        init: function () {

            let that = this;

            let $window = $(window),
                $body = $('body');

            this.initView();
            // this.initCustom();
            // Disable animations/transitions until the page has loaded.
            $body.addClass('is-loading');
            $window.on('load', function () {
                window.setTimeout(function () {
                    $body.removeClass('is-loading');
                }, 100);
            });



        },


        //------------------------------------------------------------

        getDeviceClass: function(){
            return window.getComputedStyle(document.documentElement).getPropertyValue('--deviceClass');
        }

    }
    //------------------------------------

    //gemeinsam verfügbar machen
    if (typeof (cologic) === 'undefined')
        window.cologic = {};
    $.extend(cologic, cologicCore);
}());

